import { render, staticRenderFns } from "./Names.vue?vue&type=template&id=5e99f865&scoped=true&"
import script from "./Names.vue?vue&type=script&lang=ts&"
export * from "./Names.vue?vue&type=script&lang=ts&"
import style0 from "./Names.vue?vue&type=style&index=0&id=5e99f865&scoped=true&lang=sass&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e99f865",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VRow})
